import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import Select, { components } from "react-select";
import MaterialReactTable from "material-react-table";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { Box, Button } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import AdminHeaderNew from "../NewAdminPanel/Common/AdminHeader";
import AdminSideBarNew from "../NewAdminPanel/Common/AdminSideBar";
import AdminFooterNew from "../NewAdminPanel/Common/AdminFooter";
import { ExportToCsv } from "export-to-csv";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import { MapContainer, TileLayer, Polygon, useMap } from "react-leaflet";

// Fix default marker icons broken by webpack
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
    iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
    iconUrl: require("leaflet/dist/images/marker-icon.png"),
    shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

const WMSTileLayer = ({ url, layers, ...props }) => {
    const map = useMap();
    
    useEffect(() => {
        const wmsLayer = L.tileLayer.wms(url, {
            layers: layers,
            format: 'image/png',
            transparent: true,
            attribution: 'Bhuvan NRSC',
            maxZoom: 18,
            version: '1.1.1',
            srs: 'EPSG:3857',
            Maxresolution: 156543.033928,
            styles: '',
            ...props
        }).addTo(map);

        return () => {
            map.removeLayer(wmsLayer);
        };
    }, [map, url, layers, props]);

    return null;
};
const FitBoundsToPolygon = ({ points }) => {
    const map = useMap();
    useEffect(() => {
        if (points && points.length > 0) {
            const bounds = L.latLngBounds(points.map((p) => [p.lat, p.lng]));
            map.fitBounds(bounds, { padding: [24, 24] });
        }
    }, [map, points]);
    return null;
};

const AssetsReportOp = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [optionState, setOptionState] = useState([]);
    const [stateValue, setStateValue] = useState([]);
    const [optionDistrict, setOptionDistrict] = useState([]);
    const [districtValue, setDistrictValue] = useState("");
    const [optionSubDistrict, setOptionSubDistrict] = useState([]);
    const [subdistrictValue, setsubDistrictValue] = useState("");
    const [optionVillage, setOptionVillage] = useState([]);
    const [villageValue, setvillageValue] = useState("");
    const [farmerData, setfarmerData] = useState([]);
    const [isFetching, setIsFetching] = useState(false);
    const [LoaderFarmer, setLoaderFarmer] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [infoMessage, setInfoMessage] = useState("");
    const [hasSearched, setHasSearched] = useState(false);
    const [header, setHeader] = useState("Assets Report");
    const [isStateDisabled, setIsStateDisabled] = useState(false);
    const [isDistrictDisabled, setIsDistrictDisabled] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    const [assetDetails, setAssetDetails] = useState(null);
    const [loadingDetails, setLoadingDetails] = useState(false);
    const [lightboxSrc, setLightboxSrc] = useState(null);

    const schemeCode = sessionStorage.getItem("schemeCodeModel");
const bhuvanLayerUrl = 'https://bhuvan-ras1.nrsc.gov.in/tilecache/tilecache.py';
    const baseUrl =
        process.env.NODE_ENV === "development"
            ? process.env.REACT_APP_DEV_MODE
            : process.env.REACT_APP_PRO_MODE;

    useEffect(() => {
        if (schemeCode !== "14") {
            navigate("/newadminpanel/farmer");
        }
    }, [schemeCode, navigate]);

    useEffect(() => {
        try {
            const navHeader = location?.state?.header
                ? String(location.state.header)
                : "";
            const storedHeader = sessionStorage.getItem("farmerHeader") || "";
            const nextHeader = navHeader || storedHeader || "Assets Report";
            setHeader(nextHeader);
            if (navHeader) {
                sessionStorage.setItem("farmerHeader", navHeader);
            }
        } catch (_) {}
    }, [location]);

    useEffect(() => {
            getStates();
    }, []);

    const getStates = () => {
        const myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        fetch(`${baseUrl}/api/states`, {
            method: "GET",
            headers: myHeaders,
            redirect: "follow",
        })
            .then((response) => response.text())
            .then((result) => {
                const localFormDataState = JSON.parse(result).dataContent || [];
                const myArray = localFormDataState.map((item) => ({
                    value: item.stateCode,
                    label: item.stateName,
                }));
                setOptionState(myArray);

                const userType = sessionStorage.getItem("userTypeCodeModel");
                const userTypeCode = Number.isNaN(Number(userType)) ? 0 : Number(userType);
                const stateCode = sessionStorage.getItem("stateNameModel");
                const districtCode = sessionStorage.getItem("districtNameModel");

                if (userTypeCode >= 2 && stateCode && stateCode !== "null") {
                    const matchingState = myArray.find(
                        (s) => String(s.value) === String(stateCode)
                    );
                    const nextStateCode = matchingState ? matchingState.value : stateCode;
                    setStateValue([nextStateCode]);
                    setIsStateDisabled(true);
                    handleState(nextStateCode, userTypeCode >= 3 ? districtCode : "");
                } else {
                    setIsStateDisabled(false);
                    setIsDistrictDisabled(false);
                }
            })
            .catch((error) => console.error("Error fetching states:", error));
    };

    const handleState = (stateCodeParam = "", districtCodeParam = "") => {
        const currentStateValue = stateCodeParam ? [stateCodeParam] : stateValue;
        setOptionDistrict([]);
        setDistrictValue("");
        setIsDistrictDisabled(false);
        setOptionSubDistrict([]);
        setsubDistrictValue("");
        setOptionVillage([]);
        setvillageValue("");

        if (!currentStateValue || currentStateValue.length === 0) return;

        const stateValueData = currentStateValue.join(",");

        fetch(`${baseUrl}/api/district`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ stateCode: stateValueData.toString() }),
        })
            .then((response) => response.text())
            .then((result) => {
                const localFormDataDistrict = JSON.parse(result).dataContent || [];
                const myArrayDistrict = localFormDataDistrict.map((item) => ({
                    label: item.districtName,
                    value: item.districtCode,
                    stateid: item.stateCode,
                }));
                setOptionDistrict(myArrayDistrict);

                if (districtCodeParam && districtCodeParam !== "null") {
                    const districtOption = myArrayDistrict.find(
                        (d) => String(d.value) === String(districtCodeParam)
                    );
                    if (districtOption) {
                        setDistrictValue(districtOption.value);
                        setIsDistrictDisabled(true);
                        handleChangeDistrict(districtOption);
                    }
                }
            })
            .catch((error) => console.error("Error fetching districts:", error));
    };

    const handleChange = (selectedOption) => {
        setStateValue(selectedOption ? [selectedOption.value] : []);
        setfarmerData([]);
        setErrorMessage("");
        setInfoMessage("");
        setHasSearched(false);
        setOptionDistrict([]);
        setDistrictValue("");
        setOptionSubDistrict([]);
        setsubDistrictValue("");
        setOptionVillage([]);
        setvillageValue("");
        setIsDistrictDisabled(false);

        if (selectedOption) handleState(selectedOption.value);
    };

    const handleChangeDistrict = (selectedOption) => {
        const userType = sessionStorage.getItem("userTypeCodeModel");
        const userTypeCode = Number.isNaN(Number(userType)) ? 0 : Number(userType);

        if (
            userTypeCode >= 3 &&
            districtValue &&
            (!selectedOption || String(selectedOption.value) !== String(districtValue))
        ) {
            return;
        }

        setOptionSubDistrict([]);
        setsubDistrictValue("");
        setOptionVillage([]);
        setvillageValue("");

        if (!selectedOption) {
            setDistrictValue("");
            return;
        }

        setDistrictValue(selectedOption.value);

        fetch(`${baseUrl}/api/block`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                blockCode: 0,
                blockName: "",
                subDistrictCode: 0,
                districtCode: Number(selectedOption.value),
                visibility: 1,
            }),
        })
            .then((response) => response.text())
            .then((result) => {
                const localFormDataBlock = JSON.parse(result).dataContent || [];
                setOptionSubDistrict(
                    localFormDataBlock.map((item) => ({
                        label: item.blockName,
                        value: item.blockCode,
                    }))
                );
            })
            .catch((error) => console.error("Error fetching blocks:", error));
    };

    const handleChangeSubDistrict = (selectedOption) => {
        setvillageValue("");
        setOptionVillage([]);

        if (!selectedOption) {
            setsubDistrictValue("");
            return;
        }

        setsubDistrictValue(selectedOption.value);

        fetch(`${baseUrl}/api/village`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                blockcode: selectedOption.value,
                districtcode: districtValue || 0,
            }),
        })
            .then((response) => response.text())
            .then((result) => {
                const localFormDataVillage = JSON.parse(result).dataContent || [];
                setOptionVillage(
                    localFormDataVillage.map((item) => ({
                        label: item.villageName,
                        value: item.villageCode,
                        subDistrictCode: item.subDistrictCode,
                    }))
                );
            })
            .catch((error) => console.log("Error fetching villages:", error));
    };

    const handleChangeVillage = (selectedOption) => {
        setvillageValue(selectedOption ? selectedOption.value : "");
    };

    const handleViewDetails = async (row) => {
        setOpenModal(true);
        setLoadingDetails(true);
        setAssetDetails(null);

        const assetId = row.original.assetId ?? null;

        try {
            const res = await axios.post(
                `${baseUrl}/api/AssetOP/GetTargetAssetDetails`,
                {
                    schemeCode: Number(schemeCode),
                    ...(assetId !== null && { targetId: assetId }),
                }
            );

            if (res?.data?.success) {
                setAssetDetails(res.data.dataContent);
            } else {
                setAssetDetails([]);
            }
        } catch (err) {
            console.error(err);
            setAssetDetails([]);
        } finally {
            setLoadingDetails(false);
        }
    };

    const fetchDataFilterWise = async (overrideState = undefined, overrideDistrict = undefined, overrideSubDistrict = undefined) => {
        if (schemeCode !== "14") return;

        setLoaderFarmer(true);
        setIsFetching(true);
        setfarmerData([]);
        setInfoMessage("");

        const toNumber = (value) => {
            const parsed = Number(value);
            return Number.isNaN(parsed) ? 0 : parsed;
        };

        const stateVal = overrideState !== undefined ? overrideState : stateValue?.[0];
        const districtVal = overrideDistrict !== undefined ? overrideDistrict : districtValue;
        const subdistrictVal = overrideSubDistrict !== undefined ? overrideSubDistrict : subdistrictValue;

        const body = { schemeCode: toNumber(schemeCode) };
        if (toNumber(stateVal || 0)) body.stateCode = toNumber(stateVal);
        if (toNumber(districtVal || 0)) body.districtCode = toNumber(districtVal);
        if (toNumber(subdistrictVal || 0)) body.subDistrictCode = toNumber(subdistrictVal);

        try {
            const result = await axios.post(
                `${baseUrl}/api/AssetOP/GetTargetAssetDetails`,
                body
            );

            if (result?.data?.success) {
                const data = Array.isArray(result.data.dataContent)
                    ? result.data.dataContent
                    : [];
                setfarmerData(data);
                setInfoMessage(
                    data.length === 0 ? "No data found for the selected filters." : ""
                );
                setErrorMessage("");
            } else {
                setfarmerData([]);
                setInfoMessage("No data found for the selected filters.");
                setErrorMessage("");
            }
        } catch (error) {
            console.error("Error fetching assets report data:", error);
            setfarmerData([]);
            setInfoMessage("Unable to fetch data. Please try again.");
            setErrorMessage("");
        } finally {
            setIsFetching(false);
            setLoaderFarmer(false);
        }
    };

    const clearSearch = () => {
        const userType = sessionStorage.getItem("userTypeCodeModel");
        const userTypeCode = Number.isNaN(Number(userType)) ? 0 : Number(userType);
        const stateCode = sessionStorage.getItem("stateNameModel");
        const districtCode = sessionStorage.getItem("districtNameModel");

        setfarmerData([]);
        setErrorMessage("");
        setOptionDistrict([]);
        setOptionSubDistrict([]);
        setOptionVillage([]);
        setDistrictValue("");
        setsubDistrictValue("");
        setvillageValue("");
        setIsDistrictDisabled(false);

        if (userTypeCode >= 2 && stateCode && stateCode !== "null") {
            setStateValue([stateCode]);
            setIsStateDisabled(true);
            handleState(stateCode, userTypeCode >= 3 ? districtCode : "");
            return;
        }

        setStateValue([]);
        setIsStateDisabled(false);
    };

    const ValidateAddUser = () => {
        if (!stateValue || stateValue.length === 0) {
            setErrorMessage("Please select a State.");
            return;
        }
        setErrorMessage("");
        setInfoMessage("");
        setHasSearched(true);
        fetchDataFilterWise(stateValue?.[0], districtValue, subdistrictValue);
    };

    const handleExportData = () => {
        const csvOptions = {
            fieldSeparator: ",",
            quoteStrings: '"',
            decimalSeparator: ".",
            showLabels: true,
            useBom: true,
            useKeysAsHeaders: false,
            headers: [
                "S.No",
                "Financial Year",
                "Surveyor Name",
                "State",
                "District",
                "Sub District",
                "Village",
                "Asset Area (in Ha)",
                "Component Name",
                "Category Name",
                "Agency Name",
                "yearOfEstablishment",
                "capacity",
                "capacityUnit",
                "plantMaterialAgainstCapacity",
                "Survey No."
                
            ],
        };

        const csvExporter = new ExportToCsv(csvOptions);
        const exportData = farmerData.map((row, index) => ({
            sno: index + 1,
            financialYear: row.financialYear || "",
            surveyorName:row.surveyorName || "",
            stateName: row.stateName || "",
            districtName: row.districtName || "",
            subDistrictName: row.subdistrictName || "",
            villageName: row.villageName || "",
            assetAreaInHa: row.assetAreaInHa || "",
            componentName: row.componentName || "",
            categoryName: row.categoryName || "",
            agencyName: row.agencyName || "",
            yearOfEstablishment: row.yearOfEstablishment || "",
            capacity: row.capacity || "",
            capacityUnit: row.capacityUnit || "",
            plantMaterialAgainstCapacity: row.plantMaterialAgainstCapacity || "",
            surveyNo:row.surveyNo || ""
        }));

        csvExporter.generateCsv(exportData);
    };

    const columns = useMemo(
        () => [
            {
                header: "S.No",
                size: 0,
                Cell: ({ row }) => row.index + 1,
            },
            {
                header: "Action",
                size: 120,
                Cell: ({ row }) => (
                    <span
                        style={{ cursor: "pointer", color: "green" }}
                        onClick={() => handleViewDetails(row)}
                    >
                        👁️
                    </span>
                ),
            },
            {
                header: "Financial Year",
                accessorKey: "financialYear",
            },
            {
                header: "State",
                accessorKey: "stateName",
            },
            {
                header: "District",
                accessorKey: "districtName",
            },
            {
                header: "Sub District",
                accessorKey: "subdistrictName",
            },
            {
                header: "Village",
                accessorKey: "villageName",
            },
            {
                header: "Asset Area (in Ha)",
                accessorKey: "assetAreaInHa",
            },
            {
                header: "Component Name",
                accessorKey: "componentName",
            },
            {
                header: "Agency Name",
                accessorKey: "agencyName",
            },
             {
                header: "Category Name",
                accessorKey: "categoryName",
            },
        ],
        []
    );

    const hasStateSelected = Array.isArray(stateValue) && stateValue.length > 0;
    const hasDistrictSelected = Boolean(districtValue);
    const hasBlockSelected = Boolean(subdistrictValue);

    if (schemeCode !== "14") return null;

    return (
        <>
            <AdminHeaderNew />
            <AdminSideBarNew setHeader={setHeader} />

            <main id="main" className="main">
                <div className="pagetitle page_title_box d-flex align-items-center justify-content-between">
                    <nav>
                        <h1>Assets Report List - {header}</h1>
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">Assets Report List</li>
                            <li className="breadcrumb-item active">Assets Report</li>
                        </ol>
                    </nav>
                </div>

                <section className="section">
                    <div className="row surveydetailsBg">
                        <div className="col-md-3">
                            <label htmlFor="State" className="form-label">
                                State
                            </label>
                            <label style={{ color: "red" }}>*</label>
                            <Select
                                options={optionState}
                                value={
                                    stateValue && stateValue.length > 0
                                        ? optionState.find(
                                              (option) =>
                                                  String(option.value) === String(stateValue[0])
                                          )
                                        : null
                                }
                                onChange={handleChange}
                                isClearable={!isStateDisabled}
                                isSearchable={true}
                                isDisabled={isStateDisabled}
                                isMulti={false}
                                hideSelectedOptions={false}
                                placeholder="Select State"
                                classNamePrefix="select"
                                components={{
                                    Option: ({ children, ...props }) => (
                                        <components.Option {...props}>{children}</components.Option>
                                    ),
                                }}
                            />
                        </div>

                        <div className="col-md-3">
                            <label htmlFor="District" className="form-label">
                                District
                            </label>
                            <Select
                                options={hasStateSelected ? optionDistrict : []}
                                value={
                                    hasStateSelected
                                        ? optionDistrict.find(
                                              (option) =>
                                                  String(option.value) === String(districtValue)
                                          )
                                        : null
                                }
                                onChange={handleChangeDistrict}
                                isClearable={!isDistrictDisabled}
                                isSearchable={true}
                                isDisabled={isDistrictDisabled}
                                isMulti={false}
                                hideSelectedOptions={false}
                                placeholder="Select District"
                                classNamePrefix="select"
                                components={{
                                    Option: ({ children, ...props }) => (
                                        <components.Option {...props}>{children}</components.Option>
                                    ),
                                }}
                            />
                        </div>

                        <div className="col-md-3">
                            <label htmlFor="Block" className="form-label">
                                Block
                            </label>
                            <Select
                                options={hasDistrictSelected ? optionSubDistrict : []}
                                value={
                                    hasDistrictSelected
                                        ? optionSubDistrict.find(
                                              (option) =>
                                                  String(option.value) === String(subdistrictValue)
                                          )
                                        : null
                                }
                                onChange={handleChangeSubDistrict}
                                isClearable={true}
                                isSearchable={true}
                                isMulti={false}
                                hideSelectedOptions={false}
                                placeholder="Select Block"
                                classNamePrefix="select"
                                components={{
                                    Option: ({ children, ...props }) => (
                                        <components.Option {...props}>{children}</components.Option>
                                    ),
                                }}
                            />
                        </div>

                        <div className="col-md-3">
                            <label htmlFor="Village" className="form-label">
                                Village
                            </label>
                            <Select
                                options={hasBlockSelected ? optionVillage : []}
                                value={
                                    hasBlockSelected
                                        ? optionVillage.find(
                                              (option) =>
                                                  String(option.value) === String(villageValue)
                                          )
                                        : null
                                }
                                onChange={handleChangeVillage}
                                isClearable={true}
                                isSearchable={true}
                                isMulti={false}
                                hideSelectedOptions={false}
                                placeholder="Select Village"
                                classNamePrefix="select"
                                components={{
                                    Option: ({ children, ...props }) => (
                                        <components.Option {...props}>{children}</components.Option>
                                    ),
                                }}
                            />
                        </div>

                        <div className="col-md-12 d-flex justify-content-md-center mt-3">
                            <button
                                type="button"
                                className="btn btn-primary farmrbtn me-md-2"
                                onClick={ValidateAddUser}
                            >
                                Submit
                            </button>
                            <button
                                type="button"
                                className="btn btn-success me-md-2"
                                onClick={clearSearch}
                            >
                                Clear
                            </button>
                        </div>
                    </div>

                    {errorMessage && (
                        <div className="alert alert-danger" role="alert">
                            {errorMessage}
                        </div>
                    )}
                    {!errorMessage && infoMessage && hasSearched && !isFetching && (
                        <div className="alert alert-info" role="alert">
                            {infoMessage}
                        </div>
                    )}
                </section>

                {openModal && (
                    <div
                        className="modal fade show"
                        style={{ display: "block", background: "rgba(0,0,0,0.5)" }}
                    >
                        <div className="modal-dialog modal-xl">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">Asset Details</h5>
                                    <button
                                        className="btn btn-danger"
                                        onClick={() => setOpenModal(false)}
                                    >
                                        X
                                    </button>
                                </div>

                                <div className="modal-body" style={{ fontSize: "13px", maxHeight: "80vh", overflowY: "auto" }}>
                                    {(() => {
                                        const detail = assetDetails?.[0];

                                        if (loadingDetails) return <p>Loading...</p>;
                                        if (!detail) return <p>No Data Found</p>;

                                        const Section = ({ title, children }) => (
                                            <div className="mb-3">
                                                <div
                                                    style={{
                                                        background: "#eef2ef",
                                                        padding: "6px 10px",
                                                        borderLeft: "3px solid green",
                                                        fontWeight: "600",
                                                        fontSize: "13px",
                                                        marginBottom: "8px",
                                                    }}
                                                >
                                                    {title}
                                                </div>
                                                <div style={{ padding: "0px 4px" }}>{children}</div>
                                            </div>
                                        );

                                        const Field = ({ label, value }) => (
                                            <div className="col-md-3 mb-2">
                                                <div style={{ fontWeight: "600", fontSize: "11px", color: "#555" }}>
                                                    {label}
                                                </div>
                                                <div style={{ fontSize: "13px", lineHeight: "1.3" }}>
                                                    {value !== null && value !== undefined && value !== "" ? value : "-"}
                                                </div>
                                            </div>
                                        );

                                        // Parse polygon shape
                                        let polygonPoints = [];
                                        try {
                                            const raw = detail.targetPolygon?.[0]?.polygonShape;
                                            if (raw) {
                                                // Handle both strict JSON and unquoted key format
                                                const cleaned = raw
                                                    .replace(/\{lat:/g, '{"lat":')
                                                    .replace(/,lng:/g, ',"lng":');
                                                polygonPoints = JSON.parse(cleaned);
                                            }
                                        } catch (_) {
                                            polygonPoints = [];
                                        }

                                        return (
                                            <div className="container-fluid px-1">
                                                  {/* Polygon Map */}
                                                  {polygonPoints.length > 0 && (
                                                    <Section title={`Polygon Details`}>
                                                        <div
                                                            style={{
                                                                height: "320px",
                                                                width: "100%",
                                                                borderRadius: "6px",
                                                                overflow: "hidden",
                                                                border: "1px solid #ccc",
                                                            }}
                                                        >
                                                         <MapContainer
    key={detail.assetId}
    center={[polygonPoints[0].lat, polygonPoints[0].lng]}
  
                         zoom={20}
                       maxZoom={26}  
                
                 scrollWheelZoom
                  zoomControl={true}
    style={{ height: "100%", width: "100%" }}
    scrollWheelZoom={true}
>
    <WMSTileLayer
        url={bhuvanLayerUrl}
        layers="bhuvan_wbase_ind"
    />
    <Polygon
        positions={polygonPoints.map((p) => [p.lat, p.lng])}
        pathOptions={{
            color: "#2d6a2d",
            fillColor: "#4caf50",
            fillOpacity: 0.35,
            weight: 2,
        }}
    />
    <FitBoundsToPolygon points={polygonPoints} />
</MapContainer>
                                                        </div>
                                                    </Section>
                                                )}

                                                {/* Basic Info */}
                                                <Section title="Basic Information">
                                                    <div className="row g-1">
                                                        <Field label="Financial Year" value={detail.financialYear} />
                                                        <Field label="Component" value={detail.componentName} />
                                                        <Field label="Agency" value={detail.agencyName} />
                                                        <Field label="Category" value={detail.categoryName} />
                                                    </div>
                                                </Section>

                                                {/* Location */}
                                                <Section title="Location Details">
                                                    <div className="row g-1">
                                                        <Field label="State" value={detail.stateName} />
                                                        <Field label="District" value={detail.districtName} />
                                                        <Field label="Sub-District" value={detail.subdistrictName} />
                                                        <Field label="Block" value={detail.blockName} />
                                                        <Field label="Village" value={detail.villageName} />
                                                        <Field label="Survey No." value={detail.surveyNo} />
                                                        <Field label="Khasra No." value={detail.khasraNo} />
                                                    </div>
                                                </Section>

                                                {/* Asset Details */}
                                                <Section title="Asset Details">
                                                    <div className="row g-1">
                                                        <Field label="Area (Ha)" value={detail.assetAreaInHa} />
                                                        <Field label="Capacity" value={detail.capacity != null ? `${detail.capacity} ${detail.capacityUnit || ""}` : null} />
                                                        <Field label="Plant Material Against Capacity" value={detail.plantMaterialAgainstCapacity} />
                                                        <Field label="Year of Establishment" value={detail.yearOfEstablishment} />
                                                        <Field label="Year of Commencement" value={detail.yearOfCommencement} />
                                                        <Field label="Variety" value={detail.cropVarietyName} />
                                                        {/* <Field label="Crop Name" value={detail.cropName} />
                                                        <Field label="Season" value={detail.seasonName} /> */}
                                                    </div>
                                                </Section>

                                                {/* Surveyor */}
                                                <Section title="Surveyor Information">
                                                    <div className="row g-1">
                                                        <Field label="Name" value={detail.surveyorName} />
                                                        <Field label="Code" value={detail.surveyorCode} />
                                                        <Field label="Mobile" value={detail.mobileNumber} />
                                                    </div>
                                                </Section>

                                              
                                                {/* Images */}
                                                <Section title="Images">
                                                    <div className="row g-1">
                                                        {detail.targetImage?.length ? (
                                                            detail.targetImage.map((img, i) => (
                                                                <div className="col-md-3 mb-1" key={i}>
                                                                    <img
                                                                        src={img.attPath}
                                                                        alt="asset"
                                                                        className="img-fluid rounded border"
                                                                        style={{
                                                                            height: "110px",
                                                                            objectFit: "cover",
                                                                            cursor: "zoom-in",
                                                                            width: "100%",
                                                                        }}
                                                                        onClick={() => setLightboxSrc(img.attPath)}
                                                                    />
                                                                </div>
                                                            ))
                                                        ) : (
                                                            <p>No Images</p>
                                                        )}
                                                    </div>
                                                </Section>

                                            </div>
                                        );
                                    })()}
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {lightboxSrc && (
                    <div
                        onClick={() => setLightboxSrc(null)}
                        style={{
                            position: "fixed",
                            inset: 0,
                            zIndex: 9999,
                            background: "rgba(0,0,0,0.85)",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            cursor: "zoom-out",
                        }}
                    >
                        <button
                            onClick={() => setLightboxSrc(null)}
                            style={{
                                position: "absolute",
                                top: "16px",
                                right: "20px",
                                background: "red",
                                color: "#fff",
                                border: "none",
                                borderRadius: "50%",
                                width: "34px",
                                height: "34px",
                                fontSize: "18px",
                                cursor: "pointer",
                                lineHeight: "1",
                            }}
                        >
                            &times;
                        </button>
                        <img
                            src={lightboxSrc}
                            alt="enlarged"
                            onClick={(e) => e.stopPropagation()}
                            style={{
                                maxWidth: "90vw",
                                maxHeight: "90vh",
                                borderRadius: "8px",
                                boxShadow: "0 4px 32px rgba(0,0,0,0.6)",
                                cursor: "default",
                            }}
                        />
                    </div>
                )}

                <section className="section">
                    {farmerData.length > 0 ? (
                        <div className="row justify-content-lg-center">
                            <div className="col-lg-12">
                                <div className="card">
                                    <div className="card-body" style={{ padding: "0" }}>
                                        <MaterialReactTable
                                            columns={columns}
                                            data={farmerData}
                                            enableColumnOrdering
                                            enablePagination={true}
                                            state={{ isLoading: isFetching }}
                                            muiTableBodyCellProps={{
                                                sx: { px: 1, py: 0.5, whiteSpace: "nowrap" },
                                            }}
                                            muiTableHeadCellProps={{
                                                sx: { px: 1, py: 0.5, whiteSpace: "nowrap" },
                                            }}
                                            muiTableProps={{
                                                sx: {
                                                    tableLayout: "fixed",
                                                    borderCollapse: "collapse",
                                                },
                                            }}
                                            renderTopToolbarCustomActions={() => (
                                                <Box
                                                    sx={{
                                                        display: "flex",
                                                        gap: "1rem",
                                                        p: "0.5rem",
                                                        flexWrap: "wrap",
                                                    }}
                                                >
                                                    <Button
                                                        color="success"
                                                        onClick={handleExportData}
                                                        startIcon={<FileDownloadIcon />}
                                                        variant="contained"
                                                        disabled={farmerData.length === 0}
                                                    >
                                                        Export in CSV
                                                    </Button>
                                                </Box>
                                            )}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    ) : null}
                </section>

                {LoaderFarmer ? (
                    <div className="overlay">
                        <div className="overlay__inner">
                            <div className="overlay__content">
                                <span className="spinner"></span>
                            </div>
                        </div>
                    </div>
                ) : null}
            </main>

            <AdminFooterNew />
        </>
    );
};

export default AssetsReportOp;
